import React from 'react';
import { Helmet } from 'react-helmet';
import PageHero from '../components/PageHero';
import Reveal from '../components/Reveal';
import ContactCTA from '../components/ContactCTA';
import { faqs } from '../data/siteData';

const FAQPage = () => {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <Helmet>
        <title>よくあるご質問 | RYU株式会社</title>
        <meta
          name="description"
          content="酒類の法人取引、最低注文数量、全国配送、お支払い方法、海外発送など、RYU株式会社へ寄せられるご質問にお答えします。"
        />
        <meta property="og:title" content="よくあるご質問 | RYU株式会社" />
        <meta property="og:url" content="https://www.ryukk.jp/faq" />
        <meta property="og:image" content="https://www.ryukk.jp/ogp.jpg" />
        <link rel="canonical" href="https://www.ryukk.jp/faq" />
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>

      <PageHero
        label="FAQ"
        title="よくあるご質問"
        description="お取引・配送・お支払いについて、よくいただくご質問をまとめています。"
      />

      <section className="faq-page section">
        <div className="container faq-page__grid">
          <Reveal className="faq-page__intro">
            <p className="eyebrow">QUESTIONS & ANSWERS</p>
            <h2>お取引前の疑問に、<br />明確にお答えします。</h2>
            <p>こちらにないご質問は、お問い合わせフォームよりお気軽にご相談ください。</p>
          </Reveal>
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <Reveal as="details" className="faq-item" delay={(index % 4) * 60} key={faq.question}>
                <summary>
                  <span>{String(index + 1).padStart(2, '0')}</span>
                  <strong>{faq.question}</strong>
                  <i aria-hidden="true" />
                </summary>
                <div className="faq-item__answer">
                  <span>A.</span>
                  <p>{faq.answer}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <ContactCTA />
    </>
  );
};

export default FAQPage;
